import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-beyond',
  template: `
    <sbnb-apps-detail-page
      vendorCode="BeyondPricing"
      name="Beyond Pricing"
      logoTile="/assets/images/apps/beyond-logo.png"
      builtBy="Beyond"
      builtByLink="https://www.beyondpricing.com/"
      [categories]="['Dynamic pricing']"
      [permissions]="[
        AppPermission.propertyListingRead,
        AppPermission.financialsRead,
        AppPermission.reservationRead,
        AppPermission.calendarWrite,
      ]"
      email="support@beyondpricing.com"
      [beta]="false"
      [helpArticles]="[
        {
          id: '6929219',
          title: 'Connect Hospitable with Beyond to Set Dynamic Pricing',
        },
      ]">
      <ng-container description>
        <p>
          Beyond is the #1 revenue management solution designed to help short-term rental managers unlock new ways to
          make more money. Since pioneering dynamic pricing for vacation rentals in 2013, Beyond has powered over
          350,000 properties in more than 15,000 locations worldwide. By leveraging unparalleled access to real-time
          global market data, Beyond provides short-term rental managers with the
          <strong>ability to unlock, inform, and automate action</strong>
          helping you stay ahead in a competitive market.
        </p>
        <strong>Key Features for Hospitable Users</strong>

        <ul class="list list__looser">
          <li>
            <strong>Dynamic Pricing</strong>
            – Ensure your listings are always competitively priced with AI-driven algorithms that adjust rates based on
            seasonality, demand trends, and competitor pricing
          </li>
          <li>
            <strong>Market Insights & Competitive Data</strong>
            – Get real-time visibility into local market conditions, occupancy trends, and pricing benchmarks to make
            smarter revenue decisions.
          </li>
          <li>
            <strong>Portfolio Revenue Management</strong>
            – Whether you manage one property or hundreds, Beyond makes it easy to apply bulk pricing rules, track key
            performance metrics, and refine your strategy.
          </li>
          <li>
            <strong>Seamless Integration with Hospitable</strong>
            – Automatically sync Beyond's powerful pricing engine with Hospitable to keep your rates updated across
            Airbnb, Vrbo, Booking.com, and your direct booking site.
          </li>
        </ul>
        <p>
          With Beyond, you don't just get a pricing solution, you get a
          <strong>complete revenue management platform</strong>
          that enables you to make informed decisions, automate pricing, and optimize your short-term rental business
          for long-term success.
        </p>
      </ng-container>
      <strong>Demo video</strong>
      <div class="flex flex-col items-center justify-center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/zKF_tVTgHRE?si=Hx2kvI7YqvkFf5Gx"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen></iframe>
      </div>
      <sbnb-image-carousel
        [images]="[
          '/assets/images/apps/beyond/PricingDashboard.png',
          '/assets/images/apps/beyond/PricingCalendarView.png',
          '/assets/images/apps/beyond/PricingListingViewMinStays.png',
          '/assets/images/apps/beyond/PricingReservationGrid.png',
          '/assets/images/apps/beyond/PricingBookingReview.png',
          '/assets/images/apps/beyond/Insights Dashboard.png',
          '/assets/images/apps/beyond/InsightsCompSets.png',
          '/assets/images/apps/beyond/InsightsLensView.png',
          '/assets/images/apps/beyond/InsightsSearchData.png',
        ]"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
})
export class BeyondComponent {
  public AppPermission = AppPermission;
}
